document.addEventListener(
    'DOMContentLoaded',
    InitMembershipSwiper
);

function InitMembershipSwiper()
{
    var swiperList  = document.querySelectorAll('[data-quizsteps-swiper]');
    var listIndex   = 0;

    for (listIndex = 0; listIndex < swiperList.length; listIndex++)
    {
        SetupSingleSwiper(swiperList[listIndex]);
    }
}

function SetupSingleSwiper(swiperElement)
{
    var track        = swiperElement.querySelector('.quizsteps-review-track');
    var slides       = Array.prototype.slice.call(
        swiperElement.querySelectorAll('.quizsteps-review-slide')
    );
    var dotsWrapper  = swiperElement.querySelector('[data-quizsteps-dots]');
    var prevButton   = swiperElement.querySelector('[data-quizsteps-prev]');
    var nextButton   = swiperElement.querySelector('[data-quizsteps-next]');
    var autoplayMs   = Number(swiperElement.getAttribute('data-autoplay-ms'))
        || 4500;
    var dotLabel     = swiperElement.getAttribute('data-dot-label')
        || 'Show review';
    var currentSlide = 0;
    var autoplayTimer = null;

    BuildDots();
    GoToSlide(0);

    if (prevButton)
    {
        prevButton.addEventListener(
            'click',
            function PrevClickHandler()
            {
                GoToSlide(currentSlide - 1);
            }
        );
    }

    if (nextButton)
    {
        nextButton.addEventListener(
            'click',
            function NextClickHandler()
            {
                GoToSlide(currentSlide + 1);
            }
        );
    }

    if (autoplayMs > 0 && slides.length > 1)
    {
        autoplayTimer = setInterval(AutoplayTick, autoplayMs);

        swiperElement.addEventListener(
            'mouseenter',
            function PauseAutoplayHandler()
            {
                clearInterval(autoplayTimer);
            }
        );

        swiperElement.addEventListener(
            'mouseleave',
            function ResumeAutoplayHandler()
            {
                autoplayTimer = setInterval(AutoplayTick, autoplayMs);
            }
        );
    }

    function AutoplayTick()
    {
        GoToSlide(currentSlide + 1);
    }

    function BuildDots()
    {
        slides.forEach(
            function BuildSingleDot(slideItem, slidePosition)
            {
                var dotButton = document.createElement('button');
                dotButton.type = 'button';
                dotButton.setAttribute(
                    'aria-label',
                    dotLabel + ' ' + (slidePosition + 1)
                );
                dotButton.addEventListener(
                    'click',
                    function DotClickHandler()
                    {
                        GoToSlide(slidePosition);
                    }
                );
                dotsWrapper.appendChild(dotButton);
            }
        );
    }

    function GoToSlide(nextIndex)
    {
        currentSlide = (nextIndex + slides.length) % slides.length;
        track.style.transform = 'translateX(' + (-100 * currentSlide) + '%)';

        if (dotsWrapper)
        {
            var dotButtons = dotsWrapper.querySelectorAll('button');
            var dotIndex   = 0;

            for (dotIndex = 0; dotIndex < dotButtons.length; dotIndex++)
            {
                dotButtons[dotIndex].classList.toggle(
                    'active',
                    dotIndex == currentSlide
                );
            }
        }
    }
}
